module.exports = __webpack_public_path__ + "img/174.13fee6f5.jpeg";